import { render, staticRenderFns } from "./BarChartApplication.vue?vue&type=template&id=fa94a1d8&scoped=true&"
import script from "./BarChartApplication.vue?vue&type=script&lang=js&"
export * from "./BarChartApplication.vue?vue&type=script&lang=js&"
import style0 from "./BarChartApplication.vue?vue&type=style&index=0&id=fa94a1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94a1d8",
  null
  
)

export default component.exports